/**
 * ScandiPWA - Progressive Web App for Magento
 *
 * Copyright © Scandiweb, Inc. All rights reserved.
 * See LICENSE for license details.
 *
 * @license OSL-3.0 (Open Software License ("OSL") v. 3.0)
 * @package scandipwa/base-theme
 * @link https://github.com/scandipwa/base-theme
 */

import Field from 'Component/Field';
import FIELD_TYPE from 'Component/Field/Field.config';
import { CURRENCY_PLN } from 'Component/Header/Header.config';
import { CurrencySwitcher as SourceCurrencySwitcher } from 'SourceComponent/CurrencySwitcher/CurrencySwitcher.component';

import { isSignedIn } from '../../util/Auth';
import { STORE_LANGUAGE_PL } from './CurrencySwitcher.config';

import './CurrencySwitcher.style';
/** @namespace Pwa/Component/CurrencySwitcher/Component */
export class CurrencySwitcher extends SourceCurrencySwitcher {
    currencyListForStore = (availableCurrencies, storeCode) => {
        if (storeCode.indexOf(STORE_LANGUAGE_PL) === -1) {
            return availableCurrencies.filter((currency) => currency.id !== CURRENCY_PLN);
        }

        return availableCurrencies.filter((currency) => currency.id === CURRENCY_PLN);
    };

    render() {
        const {
            handleCurrencySelect,
            currencyData: {
                available_currencies_data: availableCurrencies
            } = {},
            customer,
            currencyCodeSignedIn

        } = this.props;

        const storeCode = window.location.pathname;

        const currencyList = this.currencyListForStore(availableCurrencies, storeCode);

        if (!isSignedIn() && currencyList && currencyList.length > 1) {
            return (
                <div block="CurrencySwitcher">
                    <Field
                      type={ FIELD_TYPE.select }
                      attr={ {
                          id: 'CurrencySwitcherList',
                          name: 'CurrencySwitcherList',
                          defaultValue: this.getCurrencyValue(),
                          noPlaceholder: true
                      } }
                      events={ {
                          onChange: handleCurrencySelect
                      } }
                      options={ currencyList }
                    />
                </div>
            );
        }

        if (!isSignedIn() && currencyList && currencyList.length === 1) {
            return (
                <div block="CurrencySwitcher">
                    <div block="CurrencySwitcher" elem="SignedIn">
                        { currencyList[0].value }
                    </div>
                </div>
            );
        }

        if (isSignedIn()) {
            return (
                <div block="CurrencySwitcher">
                    <div block="CurrencySwitcher" elem="SignedIn">
                        { customer?.currency ?? currencyCodeSignedIn }
                    </div>
                </div>
            );
        }

        return null;
    }
}

export default CurrencySwitcher;
